/* Search.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { Search as SearchTrigger } from '@atlaskit/navigation-system/top-nav-items';
import type { AnyEntryPoint } from '@atlassian/entry-point-types/types';
import type { SearchProps } from '../../common/types';
import { messages } from './messages';
const searchTriggerContainerStyles = null;

/**
 * __Search__
 *
 * Platform's default Global Top Navigation Search trigger.
 *
 * The trigger is safe to render during SSR and is shared across products. On
 * activation it is replaced inline by the app-provided interactive search
 * experience, which keeps ownership of product-specific providers, results,
 * routing and analytics.
 */
export function Search<TEntryPoint extends AnyEntryPoint>({
  interactionName,
  label,
  onClick,
  SearchContent
}: SearchProps<TEntryPoint>): JSX.Element | null {
  const {
    formatMessage
  } = useIntl();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const resolvedLabel = label ?? formatMessage(messages.search);
  const openSearch = useCallback((event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    if (SearchContent) {
      setIsSearchOpen(true);
    }
  }, [onClick, SearchContent]);
  if (isSearchOpen && SearchContent) {
    return <SearchContent />;
  }
  if (!SearchContent && !onClick) {
    return null;
  }
  return <div className={ax(["_39xV02N91d"])}>
			<SearchTrigger label={resolvedLabel} onClick={openSearch} interactionName={interactionName} />
		</div>;
}